import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/home.css';
import etgLogo from '../assets/etg.png';
import ufmgLogo from '../assets/Ufmg-sem nome-03.png';

import { jwtDecode } from 'jwt-decode';
// Toast styles are inline or handled differently
// Checking App.js imports: no generic Toast found. Checking components dir listing... There is no "Toast.js".
// I will create a simple Toast logic inside Home or use simple browser alert for now, OR create a Toast component.
// Creating a simple Toast component inside Home or separate file is better.
// Let's create a simple internal Toast for Home for now to keep it self contained or I will create a Toast component file.
// Ideally I should check if there is a Toast component. I saw components folder has many files.
// Let's try to assume I need to create one if not exists.
// I will create a simple notification state in Home without external Toast for simplicity if one doesn't exist, to avoid extra file overhead unless needed.
// Actually, looking at the previous file content of App.js, there is no Toast.
// I'll implement a simple inline toast or just use standard alert for simplicity as requested "create everything from 0", but "rich aesthetics" rule applies.
// I will add a simple Toast notification div in Home.

const Home = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));
  const token = localStorage.getItem('accessToken');
  let canEditTipoTables = false;
  let canCreateQuestionario = false;
  let userProfileId = null;

  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      canEditTipoTables = decodedToken.edita_tabela_tipo === true || decodedToken.editar_tabelastipo === true;
      canCreateQuestionario = decodedToken.cria_questionario === true;
      userProfileId = decodedToken.id_perfil;
    } catch (error) {
      console.error("Erro ao decodificar o token:", error);
      localStorage.clear();
      navigate('/login');
    }
  }

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('isAuthenticated');
    navigate('/login');
  };

  const buttonGroups = {
    '#6ffc4c': [
      { to: '/escola', label: 'Escola' },
      { to: '/pavimento', label: 'Pavimento' },
      { to: '/pavimento-imagem', label: 'Pavimento imagem' },
    ],
    '#78fac6': [
      { to: '/ambiente', label: 'Ambiente' },
      { to: '/tipo-ambiente', label: 'Tipos de ambiente', isTipo: true },
      { to: '/tipo-class-ambiente', label: 'Tipos de classificação de ambiente', isTipo: true },
      { to: '/ambiente-equipamento', label: 'Ambiente equipamento' },
      { to: '/tipo-equipamento', label: 'Tipos de equipamento', isTipo: true },
      { to: '/ambiente-imagem', label: 'Ambiente imagem' },
      { to: '/tipo-material-teto', label: 'Tipo de material do teto', isTipo: true },
      { to: '/tipo-material-piso', label: 'Tipo de material do piso', isTipo: true },
    ],
    '#a0f0d0': [
      { to: '/sensores-iot-ambiente', label: 'Dispositivo IoT', isTipo: true },
      { to: '/tipo-sensor', label: 'Tipos de dispositivo IoT', isTipo: true },
      { to: '/ambiente-sensor', label: 'Ambiente dispositivo IoT' },
    ],
    '#ff2929': [
      { to: '/municipio', label: 'Município', isTipo: true },
      { to: '/superintendencia', label: 'Superintendência', isTipo: true },
      { to: '/estado', label: 'Estado', isTipo: true },
      { to: '/regional', label: 'Regional', isTipo: true },
    ],
    '#f6fc2d': [
      { to: '/gerencia', label: 'Gerência', isTipo: true },
      { to: '/projeto', label: 'Projeto' },
      { to: '/projeto-desenho', label: 'Projeto desenho' },
      { to: '/acao', label: 'Ação' },
      { to: '/solucao-institucional', label: 'Solução Institucional' },
      { to: '/tipo-modalidade', label: 'Tipos de modalidade', isTipo: true },
      { to: '/tipo-projeto', label: 'Tipos de projeto', isTipo: true },
      { to: '/tipo-regularizacao', label: 'Tipos de regularização', isTipo: true },
    ],
    '#e56bf2': [
      { to: '/ensino-aluno', label: 'Ensino aluno' },
      { to: '/tipo-ensino', label: 'Tipos de ensino', isTipo: true },
      { to: '/tipo-turno', label: 'Tipos de turno', isTipo: true },
    ],
    '#fc56e1': [{ to: '/tipo-representacao', label: 'Tipos de representação', isTipo: true }, { to: '/desenho', label: 'Desenho' }, { to: '/ambiente-desenho', label: 'Ambiente desenho' }, { to: '/pavimento-desenho', label: 'Pavimento desenho' }],
    '#921de0': [
      { to: '/tipo-manutencao', label: 'Tipos de manutenção', isTipo: true },
      { to: '/vistoria-imagem', label: 'Vistoria imagem' },
      { to: '/manutencao', label: 'Manutenção' },
      { to: '/manutencao-vistoria', label: 'Manutenção vistoria' },
    ],
    '#1da9e0': [{ to: '/acompanhamento', label: 'Acompanhamento' }, { to: '/solicitacao', label: 'Solicitação' }, { to: '/tipo-solicitacao', label: 'Tipos de solicitação', isTipo: true }, { to: '/imagem', label: 'Imagem' }, { to: '/solicitacao-imagem', label: 'Solicitação imagem' }],
    '#99b2ba': [
      { to: '/status', label: 'Status', isTipo: true },
      //{ to: '/log-auditoria', label: 'Log auditoria', isTipo: true },
      { to: '/perfis', label: 'Perfis', isTipo: true },
      { to: '/video', label: 'Vídeo', isTipo: true },
      // Questionário movido para ser controlado por cria_questionario
      // { to: '/questionario', label: 'Questionário Escola em Foco', isTipo: true },
      // { to: '/upload-imagem', label: 'Upload imagem', isTipo: true }
    ],
  };

  // Adicionar questionário ao grupo correto se usuário tiver permissão
  if (canCreateQuestionario) {
    buttonGroups['#99b2ba'].push({
      to: '/questionario',
      label: 'Questionário Escola em Foco',
      isTipo: false
    });
  }

  return (
    <div className="home-container">

      <div className="header">
        <div className="title-container">
          <img src={etgLogo} alt="ETG Logo" className="logo" />
          <h1>Gerenciador de dados</h1>
          <img src={ufmgLogo} alt="UFMG Logo" className="logo" />
        </div>
        <p>Escolha uma tabela para acessar</p>
      </div>

      <div className="header-actions">
        {user && user.id_tipo_usuario === 1 && (
          <Link to="/admin/usuarios-entrada" className="btn btn-primary">Admin</Link>
        )}
        {(userProfileId === 1 || userProfileId === 2) && canEditTipoTables && (
          <Link to="/usuario" className="btn btn-primary">Usuarios</Link>
        )}
        {userProfileId === 1 && (
          <Link to="/aprovacoes" className="btn btn-primary">Aprovar usuários</Link>
        )}

        <button onClick={handleLogout} className="btn btn-primary">Logout</button>
      </div>

      <div className="button-grid">
        {Object.entries(buttonGroups).map(([color, buttons]) => {
          const mainButtons = buttons.filter(btn => !btn.isTipo);
          const typeButtons = buttons.filter(btn => btn.isTipo);

          return (
            <div className="button-row" key={color}>
              <div className="main-buttons">
                {mainButtons.map(({ to, label }) => (
                  <Link
                    to={to}
                    className="btn btn-primary"
                    style={{ backgroundColor: color, color: '#000000' }}
                    key={to}
                  >
                    {label}
                  </Link>
                ))}
              </div>
              <div className="type-buttons">
                {canEditTipoTables && typeButtons.map(({ to, label }) => (
                  <Link
                    to={to}
                    className="btn btn-primary"
                    style={{ backgroundColor: color, color: '#000000' }}
                    key={to}
                  >
                    {label}
                  </Link>
                ))}
              </div>
            </div>
          );
        })}
      </div>


    </div>
  );
};

export default Home;
